import { z } from "zod";
import { iconMap } from "../../assets/icons/iconMap.js";

export const iconSchema = z.string().refine((data) => Object.hasOwn(iconMap, data), { message: "Neplatná ikona" });
